import React from "react";
import { Grid, List, Icon, Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";

//https://reactdatepicker.com
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import moment from 'moment';

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const app_stage = process.env.REACT_APP_STAGE.trim();

export const baseUrlApi = () => {
  if (app_stage === "Development") {
    // return "http://192.168.16.17/solarTool/api";

    return "https://localhost:5001/api";
  } else if (app_stage === "Production") {
    return "https://solartool.dvbsolutions.com/api";
  } else if (app_stage === "Staging") {
    return "https://solartool-staging.dvbsolutions.com/api";
  }
};

export const formModes = {
  creating: "creating",
  reading: "reading",
  updating: "updating",
  deleting: "deleting",
};

export const roofType = {
  PITCHED: "PITCHED",
  FLAT: "FLAT",
  BOTH: "BOTH",
};

export const RelationType = {
  Customer: "Customer",
  Supplier: "Supplier",
  Both: "Both",
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== "" && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail) {
    const pattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  return isValid;
};

export const isBlank = (str) => {
  return !str || /^\s*$/.test(str);
};

export const utcStringToLocalDateTime = (value) => {
  if (isBlank(value)) {
    return "";
  }

  if (!value.endsWith("Z")) {
    value = value + "Z";
  }

  var date = new Date(value);

  return date.toLocaleString();
};

export const utcStringToLocalDate = (value) => {
  if (isBlank(value)) {
    return "";
  }

  if (!value.endsWith("Z")) {
    value = value + "Z";
  }

  var date = new Date(value);

  return date.toLocaleDateString();
};

export const utcStringToDutchDate = (value) => {
  if (isBlank(value)) {
    return "";
  }

  if (!value.endsWith("Z")) {
    value = value + "Z";
  }

  var date = new Date(value);

  var options = {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  };

  return date.toLocaleDateString("nl-NL", options);
};

export const sqlDateToInputDate = (value) => {
  if (isBlank(value)) {
    return "";
  }

  return value.substring(0, 10);
};

export const utcStringToInputDate = (value) => {
  if (isBlank(value)) {
    return "";
  }

  var date = new Date(value + "Z");

  return date.toISOString().substring(0, 10);
};

export const formatStringToDateTimeUTC = (value) => {
  if (isBlank(value)) {
    return "";
  }

  var date = new Date(value);
  date.setHours(date.getHours() + 2);
  //https://stackoverflow.com/questions/25275696/javascript-format-date-time
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  // var ampm = hours >= 12 ? 'pm' : 'am';
  // hours = hours % 12;
  // hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  var strTime = hours + ":" + minutes + ":" + seconds;
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "  " + strTime;
};

export const formatDateTimeUTC = (date) => {
  date.setHours(date.getHours() + 2);
  //https://stackoverflow.com/questions/25275696/javascript-format-date-time
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  // var ampm = hours >= 12 ? 'pm' : 'am';
  // hours = hours % 12;
  // hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  var strTime = hours + ":" + minutes + ":" + seconds;
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "  " + strTime;
};

export const formatStringToDateTime = (value) => {
  if (isBlank(value)) {
    return "";
  }

  var date = new Date(value);
  //https://stackoverflow.com/questions/25275696/javascript-format-date-time
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  // var ampm = hours >= 12 ? 'pm' : 'am';
  // hours = hours % 12;
  // hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  var strTime = hours + ":" + minutes + ":" + seconds;
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "  " + strTime;
};

export const formatDateTime = (date) => {
  //https://stackoverflow.com/questions/25275696/javascript-format-date-time
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  // var ampm = hours >= 12 ? 'pm' : 'am';
  // hours = hours % 12;
  // hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  var strTime = hours + ":" + minutes + ":" + seconds;
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "  " + strTime;
};

export const getTimestampString = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // months 0-11
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

export const formatCurrency = (number) => {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  }).format(number);
};

export const formatDecimal = (number) => {
  return new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const isValidDate = (date) => {
  return /^(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/.test(date);
};

export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem("user"));

  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
}

export function renderError({ error, touched }) {
  if (touched && error) {
    return (
      <div className="ui error message">
        <div className="header">{error}</div>
      </div>
    );
  }
}

const createRenderer =
  (render) =>
  ({ input, meta, label, title, ...rest }) =>
    (
      <div title={title} className={["field", meta.error && meta.touched ? "error" : "", meta.active ? "active" : ""].join(" ")}>
        <label>{label}</label>
        {render(input, label, rest)}
        {renderError(meta)}
      </div>
    );

export const RenderDisabledField = (val, label) => (
  <div className="field">
    <label>{label}:</label>
    <input value={val} disabled={true} />
  </div>
);

export const RenderInput = createRenderer((input, label) => <input {...input} placeholder={label} disabled={input.disabled} />);

export const RenderInputMultiline = createRenderer((input, label) => <textarea {...input} placeholder={label} autoComplete="off" />);

export const RenderInputPassword = createRenderer((input, label) => <input type="password" placeholder={label} {...input} autoComplete="off" />);

export const RenderInputNumber = createRenderer((input, label) => <input type="number" {...input} autoComplete="off" />);

export const RenderInputDate = createRenderer((input, label) => <input type="date" {...input} autoComplete="off" />);

// export const RenderFieldDatePicker = ({
//   input,
//   placeholder,
//   minDate,
//   maxDate,
// }) => (
//   <DatePicker
//     className="plus-icon"
//     dateFormat="yyyy/MM/dd"
//     selected={input.value || null}
//     onChange={input.onChange}
//     minDate={minDate}
//     maxDate={maxDate}
//     disabledKeyboardNavigation
//     placeholderText={placeholder}
//   />
// );

export const RenderInputDecimal = createRenderer((input, label) => <input type="number" {...input} autoComplete="off" step="0.01" />);

export const RenderInputBoolean = createRenderer((input, label) => (
  <div className="ui checkbox">
    <input type="checkbox" {...input} checked={input.value} />
    <label>{}</label>
  </div>
));

export const RenderSelect = createRenderer((input, label, { children }) => {
  return (
    <select {...input} disabled={input.disabled}>
      {children}
    </select>
  );
});

export const RenderSelectWithSearch = createRenderer((input, label, { children, handleChange, disabled, focus }) => {
  return (
    <Dropdown
      fluid
      search
      selection
      disabled={disabled}
      name={input.name}
      placeholder={label}
      onChange={handleChange}
      options={children}
      value={input.value}
      searchInput={{ autoFocus: focus }}
    />
  );
});

export const RenderInputMultilineHtml = createRenderer((input, label) => (
  <Editor
    {...input}
    content={input.value}
    placeholder={label}
    autoComplete="off"
    init={{
      setup: (editor) => {
        /* Basic button that just inserts the date */
        editor.ui.registry.addButton("EmailFooterHtmlAlgemeen", {
          text: "Footer Algemeen",
          tooltip: "Insert Email Footer Algemeen",
          onAction: function (_) {
            editor.insertContent(EmailFooterHtmlAlgemeen());
          },
        });

        /* Basic button that just inserts the date */
        editor.ui.registry.addButton("EmailFooterButtonJohn", {
          text: "Footer John",
          tooltip: "Insert Email Footer John",
          onAction: function (_) {
            editor.insertContent(EmailFooterHtmlJohn());
          },
        });

        editor.ui.registry.addButton("PdfFooterButton", {
          text: "PDF Footer",
          tooltip: "Insert PDF Footer",
          onAction: function (_) {
            editor.insertContent(PdfFooterHtml());
          },
        });

        editor.ui.registry.addButton("PageBreakButton", {
          text: "PDF Page Break",
          tooltip: "Insert PDF Page Break (invisible on screen).",
          onAction: function (_) {
            editor.insertContent(PageBreakInPDFHtml());
          },
        });
      },
      height: 700,
      plugins: "paste link code lists table nonbreaking",
      image_advtab: true,
      menubar: "",
      paste_as_text: true,
      toolbar1:
        "code | undo redo | fontselect | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | removeformat | fontsizeselect | link",
      toolbar2:
        "numlist bullist outdent indent | table | tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | EmailFooterHtmlAlgemeen | EmailFooterButtonJohn | PdfFooterButton | PageBreakButton",
      mobile: {
        theme: "mobile",
        plugins: ["autosave", "lists", "autolink"],
        toolbar: ["undo | fontselect | formatselect | bold italic | numlist bullist | fontsizeselect | link"],
      },
    }}
    onBlur={(event, value) => {
      input.onChange(event.target.getContent());
    }}
  />
));

// export const RenderInputMultilineHtml = createRenderer((input, label) => (
//   <Editor
//     // apiKey="bzyqvn7nqajxflj8zhka0l2nr51jnzkh3lwf1c2por1ztrbi"
//     // {...input}
//     // initialValue={input.value}
//     {...input}
//     content={input.value}
//     init={{
//       height: 500,
// paste_word_valid_elements: 'b,strong,i,em,h1,h2,h3,p,li,ul,ol,a',
// paste_retain_style_properties: 'none',
// paste_strip_class_attributes: 'none',
// paste_remove_styles: true
//       plugins: 'link image code codesample lists table nonbreaking',
//       menubar: 'table insert',
//       toolbar1:
//         'code | undo redo | bold italic | alignleft aligncenter alignright |  codesample | numlist bullist | nonbreaking | forecolor backcolor',
//       toolbar2:
//         'table | tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol'
//     }}
//     //onChange={e => input.onChange(e.target.getContent())}
//     onBlur={(event, value) => {
//       input.onChange(event.target.getContent());
//     }}
//     //onChange={this.handleEditorChange}
//   />
//   // <textarea {...input} placeholder={label} autoComplete="off" />
// ));

export const ShowBoolean = (val) => (val ? <Icon className="green check" /> : <Icon className="x red" />);

export const RenderQuickLink = (Project) => {
  if (Project.projectStatusID === 1) {
    return <Link to={"/sales/projects/detail/" + Project.projectID}>CREATED</Link>;
  } else if (Project.projectStatusID === 2) {
    return <Link to={"/sales/visits/edit/" + (Project.visitID ? Project.visitID : Project.visit.visitID)}>VISITED</Link>;
  } else if (Project.projectStatusID === 3) {
    return <Link to={"/sales/calculations/project/" + Project.projectID}>CALCULATED</Link>;
  } else if (Project.projectStatusID === 4) {
    return <Link to={"/sales/offers/project/" + Project.projectID}>OFFERED</Link>;
  } else if (Project.projectStatusID === 5) {
    return <Link to={"/sales/orders/project/" + Project.projectID}>ORDERED</Link>;
  } else if (Project.projectStatusID === 6) {
    return <Link to={"/sales/invoices/project/" + Project.projectID}>INVOICED</Link>;
  } else {
    return <React.Fragment>{Project.projectStatus.code}</React.Fragment>;
  }
};

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function btoaUTF16(sString) {
  var aUTF16CodeUnits = new Uint16Array(sString.length);
  Array.prototype.forEach.call(aUTF16CodeUnits, function (el, idx, arr) {
    arr[idx] = sString.charCodeAt(idx);
  });
  return btoa(String.fromCharCode.apply(null, new Uint8Array(aUTF16CodeUnits.buffer)));
}

export function atobUTF16(sBase64) {
  var sBinaryString = atob(sBase64),
    aBinaryView = new Uint8Array(sBinaryString.length);
  Array.prototype.forEach.call(aBinaryView, function (el, idx, arr) {
    arr[idx] = sBinaryString.charCodeAt(idx);
  });
  return String.fromCharCode.apply(null, new Uint16Array(aBinaryView.buffer));
}

export const usableTags = () => {
  return (
    <React.Fragment>
      <h4>Possible Tags in Body and Subject (case sensitive):</h4>
      <Grid stackable columns={4}>
        <Grid.Column>
          <List>
            <List.Item>[FullName]</List.Item>
            <List.Item>[FirstName]</List.Item>
            <List.Item>[MiddleName]</List.Item>
            <List.Item>[LastName]</List.Item>
            <List.Item>[DisplayName]</List.Item>
            <List.Item>[Title]</List.Item>
            <List.Item>[SignatureName]</List.Item>
          </List>
        </Grid.Column>
        <Grid.Column>
          <List>
            <List.Item>[CompanyName]</List.Item>
            <List.Item>[Street]</List.Item>
            <List.Item>[Number]</List.Item>
            <List.Item>[NumberAddition]</List.Item>
            <List.Item>[City]</List.Item>
            <List.Item>[ZipCode]</List.Item>
            <List.Item>[CountryName]</List.Item>
          </List>
        </Grid.Column>
        <Grid.Column>
          <List>
            <List.Item>[PhoneNumber]</List.Item>
            <List.Item>[Email]</List.Item>
            <List.Item>[ProjectName]</List.Item>
            <List.Item>[YearlyConsumption]</List.Item>
            <List.Item>[DesiredYield]</List.Item>
            <List.Item>[VisitDate]</List.Item>
            <List.Item>[CurrentDate]</List.Item>
          </List>
        </Grid.Column>
        <Grid.Column>
          <List>
            <List.Item>[RoofDirection]</List.Item>
            <List.Item>[CablePlan]</List.Item>
            <List.Item>[VisitorName]</List.Item>
            <List.Item>[MetersCableUnderground]</List.Item>
            <List.Item>[PavementType]</List.Item>
            <List.Item>[RoofThroughput]</List.Item>
          </List>
        </Grid.Column>
      </Grid>
      <br />
    </React.Fragment>
  );
};

export const GoogleHelperLink = (label, query) => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${query}`}>
      {label}
    </a>
  );
};

export const EmailHelperLink = (label, query) => {
  return <a href={`mailto:${query}`}>{label}</a>;
};

export const PhoneNumberHelperLink = (label, query) => {
  return <a href={`tel:${query}`}>{label}</a>;
};

export const PageBreakInPDFHtml = () => {
  return `<div style="page-break-after:always"></div>`;
};

export const EmailFooterHtmlAlgemeen = () => {
  return `<div>
  <p>Zonnige groet,<br /><b>Team de Laat</b></p>
  <p>
    <img
      alt="logo"
      src="data:image/png;base64,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"
    />
  </P>
  <p>Kloosterheulweg 12 | 5145 NZ Waalwijk<br />Tel: 0416 533 982</p>
  <p><a href="https://www.delaat-solarsystems.nl">www.delaat-solarsystems.nl</a></p>
  </div>`;
};

export const EmailFooterHtmlJohn = () => {
  return `<div>
  <p>Zonnige groet,<br /><b>John van Woerkom</b></p>
  <p>
    <img
      alt="logo"
      src="data:image/png;base64,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"
    />
  </P>
  <p>Kloosterheulweg 12 | 5145 NZ Waalwijk<br />Tel: 0416 533 982</p>
  <p><a href="https://www.delaat-solarsystems.nl">www.delaat-solarsystems.nl</a></p>
  </div>`;
};

export const PdfFooterHtml = () => {
  return `<div>
  <p>Vriendelijke groet,</p>
  <p>Team de Laat,</p>
  <p>De Laat Solar<br />Kloosterheulweg 12<br />5145 NZ Waalwijk</p>
  </div>`;
};

export const forFait = [
  { Low: 0, High: 1000, Ammount: 20 },
  { Low: 1001, High: 2000, Ammount: 40 },
  { Low: 2001, High: 3000, Ammount: 60 },
  { Low: 3001, High: 4000, Ammount: 80 },
  { Low: 4001, High: 5000, Ammount: 100 },
  { Low: 5001, High: 6000, Ammount: 120 },
  { Low: 6001, High: 7000, Ammount: 140 },
  { Low: 7001, High: 8000, Ammount: 160 },
  { Low: 8001, High: 9000, Ammount: 180 },
  { Low: 9001, High: 10000, Ammount: 200 },
  { Low: 10001, High: 11000, Ammount: 220 },
  { Low: 11001, High: 12000, Ammount: 240 },
  { Low: 12001, High: 13000, Ammount: 260 },
  { Low: 13001, High: 14000, Ammount: 280 },
  { Low: 14001, High: 15000, Ammount: 300 },
];

export const VISITORS = [
  { Key: 1, Name: "Marcel", Disabled: false },
  { Key: 2, Name: "John", Disabled: false },
  { Key: 3, Name: "Freek", Disabled: false },
  { Key: 4, Name: "Rick", Disabled: false },
  { Key: 5, Name: "Marc", Disabled: true },
];

export const ARTICLE_INVENTORY_CATEGORY = [
  { Key: 1, Name: "A" },
  { Key: 2, Name: "A & B" },
  { Key: 3, Name: "A & B & C" },
];

export const calculateForfait = (wp) => {
  if (!wp) return null;

  const wpRounded = Math.round(wp);
  if (!wpRounded) return null;

  const forFaitAmmount = forFait.find((x) => x.Low <= wpRounded && x.High >= wpRounded);

  return forFaitAmmount ? forFaitAmmount.Ammount : null;
};

export function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function parseBoolean(value) {
  if (typeof value === "string") {
    value = value.trim().toLowerCase();
    return value === "true" || value === "1" || value === "yes" || value === "y";
  }
  return !!value; // Convert other types to boolean
}
